<div class="d-flex flex-column" [ngClass]="{'error-wrapper': forError, 'msg-wrapper': !forError}">
    <p class="label">{{msgTitle}}</p>
    <ul  [ngClass]="{'error-list': forError, 'msg-list': !forError}">
        <li class="list-item" *ngFor="let item of msgs">
            {{ item }}
        </li>
    </ul>
</div>